module.exports = __webpack_public_path__ + "static/media/bg-image-30.db7390d1.jpg";